<template>
  <b-modal
    id="cms-create-referral"
    title="New Referral"
    no-close-on-backdrop
    size="lg"
    @ok="onOk"
  >
    <ValidationObserver ref="cmsForm" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          v-slot="{ errors }"
          name="title"
          :rules="{
            required: false,
          }"
        >
          <b-form-group label="Title">
            <b-form-input
              id="title"
              v-model="createReferralForm.title"
              :state="errors[0] ? false : null"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="image_src"
          :rules="{
            required: false,
          }"
        >
          <b-form-group label="Image">
            <CmsFileSelect
              :value="createReferralForm.imageSrc"
              :state="errors[0] ? false : null"
              @update="(value) => (createReferralForm.imageSrc = value || '')"
            />
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="content"
          :rules="{
            required: false,
          }"
        >
          <b-form-group label="Content">
            <vue-editor
              v-model="createReferralForm.content"
              :state="errors[0] ? false : null"
            />
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="position"
          :rules="{
            required: true,
          }"
        >
          <b-form-group label="Position">
            <b-form-input
              id="position"
              v-model="createReferralForm.position"
              :state="errors[0] ? false : null"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    CmsFileSelect: () => import('../file-select.vue'),
    VueEditor,
  },
  data() {
    return {
      createReferralForm: {
        position: 0,
        title: '',
        imageSrc: '',
        content: '',
      },
    }
  },
  computed: {
    ...mapState({
      isCreatingCmsSiteReferrals: (state) =>
        state.cms.isCreatingCmsSiteReferrals,
    }),
    ...mapGetters(['siteId']),
  },
  methods: {
    ...mapActions(['createCmsReferrals']),
    async onOk(e) {
      e.preventDefault()
      const valid = await this.$refs.cmsForm.validate()
      if (valid) {
        this.onSubmit(() => this.$bvModal.hide('cms-create-referral'))
      }
    },
    async onSubmit(cb) {
      await this.createCmsReferrals({
        siteId: this.siteId,
        referrals: [this.createReferralForm],
      })

      cb()
    },
  },
}
</script>
